import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';

import styles from '../../containers/StewardAssetEditPage/StewardAssetEditPage.scss';

const propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  field: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  validation: PropTypes.arrayOf(PropTypes.string),
  value: PropTypes.string,
  maxChar: PropTypes.number,
  fullWidth: PropTypes.bool,
  onChange: PropTypes.func.isRequired
};

const defaultProps = {
  id: null,
  value: '',
  required: false,
  disabled: false,
  readOnly: false,
  validation: []
};

export default class TextBoxInput extends PureComponent {
  render () {
    const id = this.props.id || `${uniqueId('text-box-')}_${this.props.field.replace('.', '_')}`;
    const label = !this.props.label ? null : (
      <label htmlFor={id}>{this.props.label}</label>
    );
    const maxChar = !this.props.maxChar ? null : (
      <p>{this.props.maxChar} character limit</p>
    );
    const validation = !this.props.validation ? null : (
      <ul>{this.props.validation.map((err) => (
        <li key={err}>{err}</li>
      ))}
      </ul>
    );
    const validationCSS = this.props.validation.length > 0 ? styles["validation-problems"] : "";
    const requiredCSS = this.props.required ? styles.required : "";
    const fullWidthCSS = this.props.fullWidth ? styles["full-width"] : "";
    const css = `${styles["text-input"]} ${requiredCSS} ${fullWidthCSS} ${validationCSS}`;
    const { field, disabled, readOnly, onChange } = this.props;

    return (
      <div className={css}>
        {label}
        {maxChar}
        <textarea
          id={id}
          data-field={field}
          disabled={disabled}
          readOnly={readOnly}
          maxLength={this.props.maxChar ? this.props.maxChar : undefined}
          value={this.props.value}
          onChange={onChange} />
        {validation}
      </div>
    );
  }
}

TextBoxInput.propTypes = propTypes;
TextBoxInput.defaultProps = defaultProps;
